import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=085322bc&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=085322bc&lang=stylus&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "085322bc",
  null
  
)

export default component.exports